<ng-container *ngIf="errorMessage()">
  <span [id]="errorKey">{{ errorMessage() }}</span>
</ng-container>
